import M from 'moment';
import DashboardReportComponent from '../components/DashboardReportComponent';
import TablePanelComponent from '72cms-ui/components/dashboard-elements/TablePanelComponent';
import ListPanelComponent from '72cms-ui/components/dashboard-elements/ListPanelComponent';
import ContentListPanelComponent from '72cms-ui/components/dashboard-elements/ContentListPanelComponent';

export default {
    title: '',
    sections: [
        {
            name: 'reports',
            component: {
                template: `<div>
                    <div class="row">
                        <div class="col">
                            <slot name="chart" />
                        </div>
                    </div>
                </div>`
            }
        }
    ],
    parts: {
        chart: {
            section: 'reports',
            position: 0,
            component: DashboardReportComponent,
            config: {
                label: 'Campaign Reports',
                emptyText: 'No reports',
                endpoint: '/campaign_reports',
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/dashboard.js